// extracted by mini-css-extract-plugin
module.exports = {"carousel":"BaseCarousel_carousel__9gR6A","carousel__header-container":"BaseCarousel_carousel__header-container__s4qSZ","carousel__heading":"BaseCarousel_carousel__heading__eghPz"};